<template>
  <div :class="['le-tag', {'disabled': !enabled}]" v-tooltip="{ content: tagTooltip, html: false, autoHide: false }">
    <span :class="['label', {'clickable': clickable}]" @click="onSelectClick">{{ tag[valueAttr] }}</span>
    <i class="ico-6 ico-close" tabindex="-1" @click="onUnselectClick"></i>
  </div>
</template>

<script>
  export default {
    name: 'le-tag',
    props: {
      tag: {
        type: Object,
        required: true,
      },
      valueAttr: {
        type: String,
        default: 'value',
      },
      idAttr: {
        type: String,
        default: 'id',
      },
      subtextAttr: {
        type: String,
        default: 'subtext',
      },
      enabled: {
        type: Boolean,
        default: true,
      },
      clickable: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      tagTooltip() {
        return this.tag[this.subtextAttr] ? `${this.tag[this.valueAttr]} - ${this.tag[this.subtextAttr]}` : '';
      },
    },
    methods: {
      onUnselectClick() {
        if (this.enabled) {
          this.$emit('unselect');
        }
      },
      onSelectClick() {
        if (this.clickable && this.enabled) {
          this.$emit('select');
        }
      },
    },
  };
</script>

<style lang="scss">
  .le-tag {
    border-radius: 1px;
    padding: 0 7px 0 4px;
    font-size: 11px;
    display: inline-block;
    line-height: 18px;
    margin: 1px 6px 5px 0;
    @include themify {
      border: 1px solid getColor('tagBorder');
      color: getColor('tagsText');
    }
    @include disable-user-select();
    word-break: break-all;
    .label {
      vertical-align: middle;
      &.clickable {
        cursor: pointer;
      }
    }
    .ico-close {
      border: none;
      outline: none;
      cursor: pointer;
      margin-left: 2px;
      @include themify {
        color: getColor('tagClose');
      }
    }
    &.disabled {
      @include themify {
        border-color: getColor('disabled');
        background-color: getColor('tagsBackgroundDisabled');
        color: getColor('tagsTextDisabled');
      }
      .label {
        cursor: default;
      }
      .ico-close {
        cursor: default;
        @include themify {
          color: getColor('disabled');
        }
      }
    }
  }

</style>
